import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import AnimatedZipInput from "components/source/shared/animated_inputs/animated-zip-input";
import { validations } from "rtr-constants";

const zipCodeValidator = validations.zipCode.zipCodeValidator;
const errorMessage = "Sorry, we do not ship to this ZIP";

class GridTopFiltersZip extends React.Component {
  static propTypes = {
    ctaText: PropTypes.string,
    onSubmit: PropTypes.func,
    workingFilters: PropTypes.object,
    zipCode: PropTypes.string,
  };

  state = {
    enableZipCodeSubmit: true,
    zipCode: this.props.workingFilters.zip_code,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.workingFilters !== this.props.workingFilters) {
      this.setState({
        zipCode: this.props.workingFilters.zip_code,
      });
    }
  }

  validZipCode(zipCode) {
    return zipCode && !!zipCode.match(zipCodeValidator);
  }

  newZipCode(zipCode) {
    return zipCode && zipCode !== this.props.zipCode;
  }

  submitZipCode = e => {
    if (e?.preventDefault) {
      e.preventDefault();
    }

    const zipCode = this.state.zipCode;
    this.props.onSubmit({ zip_code: zipCode });
  };

  onChangeCallback = currentInput => {
    this.setState({
      enableZipCodeSubmit: this.validZipCode(currentInput),
      zipCode: currentInput,
    });
  };

  render() {
    return (
      <form className="grid-top-filters-zip">
        <div className="grid-top-filters__content">
          <AnimatedZipInput
            id="zip-input"
            name="filters[zip_code]"
            additionalClassName="grid-top-filters__zip-input"
            label="ZIP Code"
            validationErrorMsg={errorMessage}
            value={this.state.zipCode}
            onBlurCallback={_.noop}
            onChangeCallback={this.onChangeCallback}
            focus={true}
            required={true}
          />
        </div>
        <div className="grid-top-filters__buttons">
          <button type="submit" disabled={!this.state.enableZipCodeSubmit} className="btn" onClick={this.submitZipCode}>
            {this.props.ctaText ? this.props.ctaText : "Save"}
          </button>
        </div>
      </form>
    );
  }
}

export default GridTopFiltersZip;
